import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import {
  useDeleteCommentMutation,
  useUpdateCommentMutation,
} from '../../../../store/api/commentApi';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../store/auth/authSlice';
import { toast } from 'react-toastify';
import { useContext } from 'react';
import { AppContext } from '../../../../context/ContextProvider';

const CommentContent = styled('div')({
  margin: '0',
  marginTop: '6px',
});

const CommentActions = styled('div')({
  display: 'flex',
  margin: '10px 0',
});

const CommentAction = styled(Button)({
  marginRight: '10px',
  padding: '0',
  border: 'none',
  color: '#656666',
  fontSize: '13px',
  lineHeight: '15px',
  textTransform: 'uppercase',
  minWidth: 'auto',
  '&:last-of-type': {
    color: '#FF6161',
    marginRight: '0',
  },
  '&:disabled': {
    color: 'grey',
  },
});

const RepliedUser = styled('span')({
  color: '#656666',
});

const CommentInput = styled('input')({});

const CommentDetails = ({
  noteId,
  noteAuthorId,
  commentId,
  commentProps,
  isParent,
  replyComment,
}) => {
  const { text, replyTo, author, parentCommentId } = commentProps;
  const [isEditing, setIsEditing] = useState(false);
  const [textChanged, setTextChanged] = useState(text);
  const { isShow, setIsShow, isLogin, setIsLogin } = useContext(AppContext);

  const [deleteComment] = useDeleteCommentMutation();
  const [updateComment] = useUpdateCommentMutation();
  const currentUserId = useSelector(selectUser);

  const clickReply = () => {
    const replyToUserName = author.name;
    // if parent comment is replied
    if (isParent) {
      replyComment({ parentComment: commentId, replyToUserName });
    } else {
      // if child comment is replied
      replyComment({ parentComment: parentCommentId, replyToUserId: author.id, replyToUserName });
    }
  };

  const clickOk = async () => {
    await updateComment({ noteId, commentId, text: textChanged });
    setIsEditing(false);
  };

  const clickDelete = async () => {
    await deleteComment({ noteId, commentId });
  };
  const isBlock = !currentUserId || !isLogin;
  const clickToast = () => {
    if (isBlock) {
      toast.success('Please Sign in first.');
    }
    return;
  };

  const Content = () => {};

  const Actions = () => {
    if (isEditing) {
      return (
        <CommentActions>
          <CommentAction onClick={clickOk}>OK</CommentAction>
          <CommentAction onClick={() => setIsEditing(false)}>Cancel</CommentAction>
        </CommentActions>
      );
    }
    return (
      <CommentActions onClick={clickToast}>
        <CommentAction onClick={clickReply} disabled={isBlock}>
          Reply
        </CommentAction>
        {isLogin && author.id === currentUserId && (
          <CommentAction onClick={() => setIsEditing(true)}>Edit</CommentAction>
        )}
        {((isLogin && currentUserId === author.id) || currentUserId === noteAuthorId) && (
          <CommentAction onClick={clickDelete}>Delete</CommentAction>
        )}
      </CommentActions>
    );
  };

  return (
    <>
      {isEditing ? (
        <CommentInput
          value={textChanged}
          type="text"
          onChange={(e) => setTextChanged(e.target.value)}
        />
      ) : (
        <CommentContent>
          {replyTo ? (
            <>
              Reply <RepliedUser>{replyTo.name}</RepliedUser>：
            </>
          ) : (
            ''
          )}
          {text}
        </CommentContent>
      )}
      <Actions />
    </>
  );
};
export default CommentDetails;
